import React from "react";
/** @jsx jsx */
import { jsx } from "@emotion/core";

import { useAuth } from "../../../../auth";
import { SiteLink, useRouter } from "../../../../components";

export function LoginStatus(props) {
  const auth = useAuth();
  const router = useRouter();

  function signout(e) {
    e.preventDefault();
    e.stopPropagation();

    auth
      .signout()
      .then((user) => {
        router.push("/admin/login");
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const email = (auth.user && auth.user.email) || "";

  if (router.path === "/admin/login") return null;
  if (!auth.isResolved) return null;
  return (
    <div
      css={{
        position: "absolute",
        top: "1rem",
        right: "0.5rem",
        a: {
          color: "white",
        },
      }}
    >
      {auth.user ? (
        <React.Fragment>
          <SiteLink to="/admin/dashboard" style={{ fontSize: "80%", marginRight: "0.5rem" }}>
            {email}
          </SiteLink>
          <button className="btn btn-primary btn-sm" onClick={(e) => signout(e)}>
            Logout
          </button>
        </React.Fragment>
      ) : (
        <SiteLink className="btn btn-primary btn-sm" to="/admin/login">
          Login
        </SiteLink>
      )}
    </div>
  );
}
